import {
    collection,
    component,
    EntityData,
    field,
    identifier,
    LocalisableEntityData,
    transientCollection,
    transientField
} from "@fedeltapointofsale/data-client";
import {ItemDisplayInfo} from "./screen-layout-edit-page/screen-layout-editor/item-display-info";
import {CourseDefinitionReferenceData} from "../course-definition/course-definition.data";
import {SellableReferenceData} from "../../catalogue/sellable/sellable.data";

export enum ITEM_TYPE {
    MENU_BAR_PREV = -7,
    MENU_BAR_NEXT = -6,
    MENU_BAR_ADD = -5,
    MENU_PREV = -4,
    MENU_NEXT = -3,
    BLANK = -2,
    MENU = -1,
    SUB_MENU = 0,
    SELLABLE = 1,
    PREP = 2,
    SIZE = 4,
    CUSTOM_FUNCTION = 5,
    EXTRA = 10
}

export class TouchItemReferenceData extends EntityData<TouchItemReferenceData> {
    @identifier id: number;
}

export class TouchItemData extends EntityData<TouchItemData> implements ItemDisplayInfo {
    @identifier id: number;
    @field itemType: ITEM_TYPE;
    @field identifier: number;
    @field applyExtraRules: boolean;
    @field sellableSizeGroup: number;
    @field listIndex: number;
    @field popup: boolean;
    @field fontName: string;
    @field fontStyle: number;
    @field fontSize: number;
    @field confCatId: number;
    @field displayName: string = "";
    @field colour: number;
    @field foreColour: number;
    @field courseId: number;
    @component parent: TouchItemReferenceData;
    @collection(TouchItemData) children: TouchItemData[];
    @field childCount: number;
    @field gridRows: number;
    @field gridColumns: number;
    @transientField icon: string;

    /**
     * Indicates that a new TouchItem has been added and it is unknown if the sellable has an icon
     */
    @transientField iconCheckRequired: boolean;
}

export class ScreenLayoutMenuData extends EntityData<ScreenLayoutMenuData> implements ItemDisplayInfo {
    @identifier confCatId: number;
    @field courseId: number;
    @field displayName: string;
    @field colour: number;
    @field foreColour: number;
    @field fontName: string;
    @field fontStyle: number;
    @field fontSize: number;
    @field gridRows: number;
    @field gridColumns: number;
    @collection(TouchItemData) touchItems: TouchItemData[];

    get itemType(): ITEM_TYPE {
        return ITEM_TYPE.MENU;
    }
}

export class ScreenLayoutDetails extends EntityData<ScreenLayoutDetails> {
    @field name: string;
    @field description: string;
    @field rows: number;
    @field columns: number;
    @field catColumns: number;
    @field fontName: string;
    @field fontStyle: number;
    @field fontSize: number;
    @component courses: CourseDefinitionReferenceData;
}

export class ScreenLayoutData extends LocalisableEntityData<ScreenLayoutData> {
    @identifier confId: number;
    @component details: ScreenLayoutDetails;
    @collection(ScreenLayoutMenuData) configCategories: ScreenLayoutMenuData[];
    @transientCollection(SellableReferenceData) itemsWithImages: SellableReferenceData[];
}
